import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-con5',
  templateUrl: './e-con5.component.html',
  styleUrls: ['./e-con5.component.css']
})
export class ECon5Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
